export default "__VITE_ASSET__35de9e0f__"